import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ViewPaymentPlanPage } from './view-payment-plan.page';

const routes: Routes = [
  {
    path: '',
    component: ViewPaymentPlanPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ViewPaymentPlanPageRoutingModule {}